import React, { useState, useMemo, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import penciledit from '../assets/images/profile-edit.svg';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { apiUrl, assetsUrl } from "../../config/Config";
import userplaceholderimg from "../../assets/images/userplaceholder.png";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faTrash,
  faEye,
  faPlus,
  faFile,
  faChevronUp,
  faChevronDown,
  faDownload,
  faArrowLeft,
  faPaperPlane
} from "@fortawesome/free-solid-svg-icons";
import { Button, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import Spinner from "react-activity/dist/Spinner";
import moment, { max, min } from "moment";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import "./UserModalStyle.css";

const UserDetailsModal = ({showmodal, hidemodal, candidateid}) => {
    const [orderstatus, setorderstatus] = useState("editprofile");
  const [showloding, setshowloding] = useState(false);
  const [error, setError] = useState("");

  const [showmatchmodal, setshowmatchmodal] = useState(false);
  const [selectedformatchobj, setselectedformatchobj] = useState({});
  const [completedbarcount, setcompletedbarcount] = useState(12);
  const [currentstep, setcurrentstep] = useState(1);
  const [forceupdate, setforceupdate] = useState(false);

  const [airesultsarrdata, setairesultsarrdata] = useState([]);
  const [selectedresultarr, setselectedresultarr] = useState([]);
  const [selectedrating, setselectedrating] = useState(null);
  const [selectedjdtitle, setselectedjdtitle] = useState(null);

  const [showtimelinemodal, setshowtimelinemodal] = useState(false);
  const [pipelinearrdata, setpipelinearrdata] = useState([]);
  const [selectedcandidateobj, setselectedcandidateobj] = useState({});
  const [showfeedback, setshowfeedback] = useState(false);
  const [addfeedbackindex, setaddfeedbackindex] = useState(false);

  const selectedcandidateobjRef = useRef();
  selectedcandidateobjRef.current = selectedcandidateobj;

  const completedbarcountRef = useRef(0);
  completedbarcountRef.current = completedbarcount;

  const selectedformatchobjRef = useRef();
  selectedformatchobjRef.current = selectedformatchobj;

  const currentstepRef = useRef();
  currentstepRef.current = currentstep;

  const selectedresultarrRef = useRef([]);
  selectedresultarrRef.current = selectedresultarr;

  const selectedratingRef = useRef([]);
  selectedratingRef.current = selectedrating;

  const selectedjdtitleRef = useRef([]);
  selectedjdtitleRef.current = selectedjdtitle;

  const [image, setimage] = useState("");

  const [candidatedetails, setcandidatedetails] = useState({});
  const [spendhistorydata, setspendhistorydata] = useState([]);
  const [bilingdata, setbilingdata] = useState([]);

  const [activesection, setactivesection] = useState("basic");
  const [activesection1, setactivesection1] = useState("spendhistory");

  const locations = useLocation();
  const { state } = locations;

  const [loading, setloading] = useState(false);
  const [message, setmessage] = useState("");
  const [messagedata, setmessagedata] = useState([]);
  const [messageloading, setmessageloading] = useState(false);
  const [wptoken, setwptoken] = useState(null);
  const [templatesdata, settemplatesdata] = useState([]);
  const [leaddata, setleaddata] = useState({});

  const [selectedtemplate, setselectedtemplate] = useState("");
  
    const templatesdataRef = useRef([]);
    templatesdataRef.current = templatesdata;
  
    const messagedataRef = useRef([]);
    messagedataRef.current = messagedata;

    const leaddataRef = useRef({});
    leaddataRef.current = leaddata;

    dayjs.extend(utc);
dayjs.extend(timezone);

// const formatDate = (created_at) => {
//     const date = new Date(created_at);
  
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();
  
//     return `${day}-${month}-${year}`;
//   };

    const formatMySQLDateToIST = (
        datetimeString,
        options = { showSeconds: true, use12Hour: false }
      ) => {
        // Parse the UTC datetime
        let m = moment.utc(datetimeString).tz("Asia/Kolkata");
    
        // Format time part
        let timeFormat = options.use12Hour ? "hh:mm" : "HH:mm";
        if (options.showSeconds) timeFormat += ":ss";
        if (options.use12Hour) timeFormat += " A";
    
        // Format date part with ordinal suffix
        const day = m.date();
        const daySuffix = ((d) => {
          if (d > 3 && d < 21) return "th";
          switch (d % 10) {
            case 1:
              return "st";
            case 2:
              return "nd";
            case 3:
              return "rd";
            default:
              return "th";
          }
        })(day);
    
        const formattedTime = m.format(timeFormat);
        const formattedDate = `${day}${daySuffix} ${m.format("MMMM YYYY")}`;
    
        return `${formattedDate}`;
      };

      const formatCreatedDateWithSuffix = (dateString) => {
        const date = new Date(dateString);
      
        const day = date.getDate();
        const year = date.getFullYear();
      
        const month = date.toLocaleString("en-IN", { month: "long" });
      
        // Add suffix (st, nd, rd, th)
        const getSuffix = (d) => {
          if (d > 3 && d < 21) return "th";
          switch (d % 10) {
            case 1: return "st";
            case 2: return "nd";
            case 3: return "rd";
            default: return "th";
          }
        };
      
        return `${day}${getSuffix(day)} ${month} ${year}`;
      }




    function formatPhoneNumber(number) {
      // Remove leading "+" if it exists
      let formatted = number.startsWith("+") ? number.slice(1) : number;
    
      // Add "91" at the start if not already present
      if (!formatted.startsWith("91")) {
        formatted = "91" + formatted;
      }
    
      return formatted;
    }

    const handlepostnewmessage = async() => {
      if(message || selectedtemplate) {
        if(selectedtemplate) {
          //template message
          console.log('leaddataRef?.current?.name >>', leaddataRef?.current?.name);
          if( leaddataRef?.current?.name) {
            
          } else {
            alert('Name, role, portal are mandatory');
            return;
          }
          // Change varibale to real values
          var prevmessage = templatesdataRef?.current[selectedtemplate]['components'][0]['text'];
          const updatevalue = {
            candidate_name: leaddataRef?.current?.name,
            platform: leaddataRef?.current?.portal ? leaddataRef?.current?.portal : "",
            jobprofile: leaddataRef?.current?.role ? leaddataRef?.current?.role : ""
          };
          var newmessage = prevmessage
          .replace("{{candidate_name}}", updatevalue.candidate_name)
          .replace("{{platform}}", updatevalue.platform)
          .replace("{{jobprofile}}", updatevalue.jobprofile);
  
  
  
          var data = {
            messaging_product : "whatsapp",
            type: "template",
            template: {"name": templatesdataRef?.current[selectedtemplate]['name'], "language": {"code": templatesdataRef?.current[selectedtemplate]['language']}},
            to: formatPhoneNumber(leaddataRef?.current?.mobile),
            wptoken: wptoken,
            message: templatesdataRef?.current[selectedtemplate]['components'][0]['text'],
            newmessage: newmessage,
            leadid: leaddataRef?.current?.id,
            name: leaddataRef?.current?.name,
            portal: leaddataRef?.current?.portal,
            role: leaddataRef?.current?.role
          }
        } else {
          //text message
          var data = {
            messaging_product : "whatsapp",
            type: "text",
            text: {"body": message},
            to: formatPhoneNumber(leaddataRef?.current?.mobile),
            wptoken: wptoken,
            message: message,
            leadid: leaddataRef?.current?.id,
            name: leaddataRef?.current?.name,
            portal: leaddataRef?.current?.portal,
            role: leaddataRef?.current?.role
          }
        }
        console.log('data >>', data);

        setmessageloading(true);
  
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
  
        const resp = await axios.post(apiUrl + "post-new-wpmessage", data, headers);
      if (resp.data.status === "success") {
        var prevdata = messagedataRef.current;
        var newobj = {
          leadid: candidatedetails?.id,
          recruiterid: userdata?.id,
          message: selectedtemplate ? data?.newmessage : data?.message,
          datetime: resp?.data?.datatime,
          number: formatPhoneNumber(candidatedetails?.mobile),
          from: "crm"
        }
        prevdata.push(newobj);
        setmessagedata(prevdata);
        setselectedtemplate("");
        setforceupdate(!forceupdate);
        setmessageloading(false);
        setmessage("");
      } else {
        setmessageloading(false);
        Swal.fire({
          text: resp.data.message,
          icon: "error",
          width: "350px",
          confirmButtonText: "Ok",
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: { popup: "small-icon-alert" },
        });
      }
      setmessageloading(false);
  
  
      } else {
        Swal.fire({
          title: "",
          text: "Empty Template/Message",
          icon: "error",
          customClass: {
            icon: "custom-swal-icon", // Apply the custom class
          },
          width: "350px",
          confirmButtonText: "Ok",
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
            popup: "small-icon-alert",
          },
        });
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault(); // optional: prevent form submit or newline
        handlepostnewmessage();
      }
    };

const appendmessagesfunc = async(id) => {
  console.log('appendmessagesfunc >>', data)
  var data = {
    userid: id,
  };
  const headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + userdata?.token,
    },
  };
  let resp = await axios
    .post(apiUrl + "getleadmessages", data, headers)
    .then((res) => {
      if (res.data.status == "success") {

        if (res.data.messagedata) {
          setmessagedata(res.data.messagedata);
          setforceupdate(!forceupdate);
        } else {
          setmessagedata([]);
          setforceupdate(!forceupdate);
        }

      } else {
        setloading(false);
        if (res.data.message == "invalid user") {
          setloading(false);
          dispatch({ type: "userdata", payload: {} });
          navigate("/login");
        } else {
          setloading(false);
          Swal.fire({
            title: "",
            text: res.data.message,
            icon: "error",
            customClass: {
              icon: "custom-swal-icon", // Apply the custom class
            },
            width: "350px",
            confirmButtonText: "Ok",
            confirmButtonColor: "rgb(59, 151, 196)",
            customClass: {
              popup: "small-icon-alert",
            },
          });
        }
      }
    })
    .catch((err) => {
      alert(err.message);
    });
}


  

  const handleaccordtoggle = (index, status) => {
    var prevdata = selectedresultarrRef.current;
    prevdata[index]["isshow"] = !status;
    setselectedresultarr(prevdata);
    setforceupdate(!forceupdate);
  };

  const handletoggleorders = (status) => {
    setorderstatus(status);
  };

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const userdata = useSelector((store) => store.userReducer.userdata);

  console.log("userdata >>", userdata);

  const getInitials = (fullName) => {
    if (!fullName) return "";

    const parts = fullName.trim().split(" ").filter(Boolean);

    if (parts.length === 1) {
      return parts[0][0].toUpperCase(); // single name
    }

    const first = parts[0][0].toUpperCase();
    const last = parts[parts.length - 1][0].toUpperCase();

    return first + last;
  };

  const convertTo12HourFormat = (timeString) => {
    // Split the string into [hours, minutes, seconds]
    let [hours, minutes, seconds] = timeString.split(":");
    hours = parseInt(hours);
  
    // Determine AM/PM
    const ampm = hours >= 12 ? "PM" : "AM";
  
    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 => 12
  
    return `${hours}:${minutes} ${ampm}`;
  };

  const validatePassword = (text) => {
    // Regular expression to match the password criteria
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

    // Check if the password matches the regex
    if (regex.test(text)) {
      setError("");
      return true;
    } else {
      setError(
        "Password must be at least 8 characters long and include a combination of uppercase, lowercase, numbers, and special characters."
      );
      return false;
    }
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // console.log(baseURL);
        resolve(baseURL);
      };
      // console.log(fileInfo);
    });
  };

  const handleinputchange = async (file) => {
    var obj = {};
    await getBase64(file).then((result) => {
      obj["name"] = file.name;
      obj["image"] = result;
    });
    // console.log('obj >>', obj);
    setimage(obj);
  };

  const handleviewdetails = (resultdata, rating, jdtitle) => {
    if (resultdata) {
      var parseddata = JSON.parse(resultdata);
      setselectedresultarr(parseddata);
    } else {
      setselectedresultarr([]);
    }
    if (rating) {
      setselectedrating(rating);
    } else {
      setselectedrating(null);
    }
    if (jdtitle) {
      setselectedjdtitle(jdtitle);
    } else {
      setselectedjdtitle(null);
    }
    setTimeout(() => {
      setshowmatchmodal(true);
    }, 1000);
    // setshowmatchmodal(true);

    // setselectedresultarr
  };

  const handleviewpipelinedetails = (data, stage) => {
    var prevdata = data;
    var timelinearr = [
      {
        title: "Profile Shared",
        date1: prevdata?.profileSharedDate,
        date2: prevdata?.reviewDate,
        feedback: prevdata?.reviewFeedback,
        reviewTimeTaken: prevdata?.reviewTimeTaken,
      },
      {
        title: "Round 1",
        date1: prevdata?.roundOneInterviewDate,
        date2: prevdata?.roundOneInterviewFeedbackDate,
        feedback: prevdata?.roundOneInterviewFeedback,
        reviewTimeTaken: prevdata?.roundOneFeedbackInDays,
      },
      {
        title: "Round 2",
        date1: prevdata?.roundTwoInterviewDate,
        date2: prevdata?.roundTwoInterviewFeedbackDate,
        feedback: prevdata?.roundTwoInterviewFeedback,
        reviewTimeTaken: prevdata?.roundTwoFeedbackInDays,
      },
      {
        title: "Round 3",
        date1: prevdata?.roundThreeInterviewDate,
        date2: prevdata?.roundThreeInterviewFeedbackDate,
        feedback: prevdata?.roundThreeInterviewFeedback,
        reviewTimeTaken: prevdata?.roundThreeFeedbackInDays,
      },
    ];
    prevdata["timelinearr"] = timelinearr;
    prevdata["gotstage"] = stage;
    console.log("candidate selected data >> ", prevdata);
    setselectedcandidateobj(prevdata);
    setshowfeedback(false);
    setTimeout(() => {
      setshowtimelinemodal(true);
    }, 500);
  };


  const fetchdata = async (id) => {
    setshowloding(true);
    setcandidatedetails({});
    setbilingdata([]);
    setspendhistorydata([]);
    var data = {
      id: id,
    };
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    let resp = await axios
      .post(apiUrl + "userdetails", data, headers)
      .then((res) => {
        if (res.data.status == "success") {
          setcandidatedetails(res.data.data);

          if (res?.data?.spenthistory?.length > 0) {
            setspendhistorydata(res?.data?.spenthistory);
          } else {
            setspendhistorydata([]);
          }

          if (res?.data?.billinghistory?.length > 0) {
            setbilingdata(res?.data?.billinghistory);
          } else {
            setbilingdata([]);
          }

         
          // navigate('/users');
        } else {
          if (res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} });
            navigate("/login");
          } else {
            Swal.fire({
              title: "",
              text: res.data.message,
              icon: "error",
              customClass: {
                icon: "custom-swal-icon", // Apply the custom class
              },
              width: "350px",
              confirmButtonText: "Ok",
              confirmButtonColor: "rgb(59, 151, 196)",
              customClass: {
                popup: "small-icon-alert",
              },
            });
          }
        }
      })
      .catch((err) => {
        alert(err.message);
      });
    setshowloding(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" }); // "May"
    const year = date.getFullYear();

    // Function to add ordinal suffix
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return "th"; // 11th–13th
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };

    useEffect(() => {
        console.log('candidateid >>', candidateid);
        if(candidateid > 0) {
            fetchdata(candidateid);
        }
        
        
    }, [candidateid]);
    return (
      <div>
        <Modal
          show={showmodal}
          onHide={() => hidemodal(false)}
          size="xl"
          className="custom-width-modal filtercandidates-pipeline-custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>
                {candidatedetails?.fullname ? "User Details | " + candidatedetails?.fullname : "User Details"}
               
            </Modal.Title>
          </Modal.Header>
           <Modal.Body>
           {showloding ? (
        <div className="mt-4">
          <Spinner color="#333" size={20} className="chatbotspinner" />
        </div>
      ) : (
        <div
          className="d-flex candidatedetails-maindiv"
          style={{ justifyContent: "space-between" }}
        >
          <div
            className="dashboardbox onboarding-candidate-lhs"
            style={{ width: "30%" }}
          >
            <div className="addproduct-save-row">
              {/* <div
                className=""
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  className=""
                  style={{ marginRight: 10, cursor: "pointer" }}
                  onClick={() => {
                    // navigate("/onboarding");
                    navigate(-1);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    className="sidebaricons"
                    style={{
                      color: "rgb(100, 116, 139)",
                      fontSize: 18,
                      position: "relative",
                      top: 13,
                    }}
                  />
                </div>
                <p
                  className="inventorysummary-text addproduct-text"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    // navigate("/onboarding");
                    navigate(-1);
                  }}
                >
                  Back
                </p>
                <div className="onboarding-top-iconrow"></div>
              </div> */}
            </div>
            <div className="userbasicinfo">
              <img
                src={userplaceholderimg}
                className="onboardingdetailplaceholderimg"
              />
              <p className="onboardingdetail-candidatename candidate-details-modal-candidatename">
                {candidatedetails?.fullname}
              </p>
              <div className="onboardingdetail-sentonrow mt-0">
                <span className="onboardingdetail-sentonrow-label">
                  Created On :
                </span>
                <span className="onboardingdetail-sentonrow-value">
                  {/* {candidatedetails?.created_at ? formatMySQLDateToIST(candidatedetails?.created_at) : null} */}
                  {candidatedetails?.created_at ? formatDate(candidatedetails?.created_at) : null}
                </span>
              </div>
            </div>
            {/* <div className="onboardingdetail-tabsdiv">
              <div
                className={
                  activesection == "basic"
                    ? "onboardingdetail-tab1 active"
                    : "onboardingdetail-tab1"
                }
                onClick={() => {
                  setactivesection("basic");
                }}
              >
                <p>Basic Info</p>
              </div>
              <div
                className={
                  activesection == "employment"
                    ? "onboardingdetail-tab1 active"
                    : "onboardingdetail-tab1"
                }
                onClick={() => {
                  setactivesection("employment");
                }}
              >
                <p>Technical Info</p>
              </div>
            </div> */}
            <hr />
            {activesection == "basic" ? (
              <div className="basicdetails-maindiv">
                {/* <div className="onbording-candidate-form-info-row">
                  <span className="onbording-candidate-form-info-label">
                    Full Name :
                  </span>
                  <span className="onbording-candidate-form-info-value">
                    {candidatedetails?.name}
                  </span>
                </div> */}

                <div className="onbording-candidate-form-info-row">
                  <span className="onbording-candidate-form-info-label">
                    Email Address :
                  </span>
                  <span className="onbording-candidate-form-info-value">
                    {candidatedetails?.emailaddress}
                  </span>
                </div>

                <div className="onbording-candidate-form-info-row">
                  <span className="onbording-candidate-form-info-label">
                    Mobile Number :
                  </span>
                  <span className="onbording-candidate-form-info-value">
                    {candidatedetails?.mobilenumber}
                  </span>
                </div>

                <div className="onbording-candidate-form-info-row">
                  <span className="onbording-candidate-form-info-label">
                    Active Plan :
                  </span>
                  <span className="onbording-candidate-form-info-value">
                    {candidatedetails?.currentplan ? candidatedetails?.currentplan : "--"}
                  </span>
                </div>

                <div className="onbording-candidate-form-info-row">
                  <span className="onbording-candidate-form-info-label">
                    Credits :
                  </span>
                  <span className="onbording-candidate-form-info-value">
                    {candidatedetails?.credits ? candidatedetails?.credits : "--"}
                  </span>
                </div>

                <div className="onbording-candidate-form-info-row">
                  <span className="onbording-candidate-form-info-label">
                    Credits Used :
                  </span>
                  <span className="onbording-candidate-form-info-value">
                    {candidatedetails?.credits_used
                      ? candidatedetails?.credits_used
                      : "--"}
                  </span>
                </div>

                <div className="onbording-candidate-form-info-row">
                  <span className="onbording-candidate-form-info-label">
                    Last Purchased :
                  </span>
                  <span className="onbording-candidate-form-info-value">
                    {candidatedetails?.lastpurchased ? candidatedetails?.lastpurchased : "--"}
                  </span>
                </div>

                <div className="onbording-candidate-form-info-row">
                  <span className="onbording-candidate-form-info-label">
                    Plan Expiry :
                  </span>
                  <span className="onbording-candidate-form-info-value">
                    {candidatedetails?.planexpiry ? candidatedetails?.planexpiry : "--"}
                  </span>
                </div>
              </div>
            ) : (
              <div className="basicdetails-maindiv">
                <div
                  className="onbording-candidate-form-info-row"
                  style={{ flexDirection: "column", gap: 5 }}
                >
                  <span className="onbording-candidate-form-info-label">
                    <strong style={{ color: "#333", fontSize: 15 }}>
                      Overview :
                    </strong>
                  </span>
                  <span className="onbording-candidate-form-info-value">
                    {candidatedetails?.overview}
                  </span>
                </div>
                <div
                  className="onbording-candidate-form-info-row"
                  style={{ flexDirection: "column", gap: 5 }}
                >
                  <span className="onbording-candidate-form-info-label">
                    <strong style={{ color: "#333", fontSize: 15 }}>
                      Experience :
                    </strong>
                  </span>
                  <span className="onbording-candidate-form-info-value">
                    {candidatedetails?.experience}
                  </span>
                </div>
              </div>
            )}
          </div>

          {/* Right div */}
          <div className="dashboardbox rhs" style={{ width: "68%" }}>
            <div className="onboardingdetail-tabsdiv onboardingdetail-tabsdiv-rhs">
              <div
                className={
                  activesection1 == "spendhistory"
                    ? "onboardingdetail-tab1 onboardingdetail-tab1-rhs active"
                    : "onboardingdetail-tab1 onboardingdetail-tab1-rhs"
                }
                onClick={() => {
                  setactivesection1("spendhistory");
                }}
              >
                <p>Spent History</p>
              </div>
              <div
                className={
                  activesection1 == "subscription"
                    ? "onboardingdetail-tab1 onboardingdetail-tab1-rhs active"
                    : "onboardingdetail-tab1 onboardingdetail-tab1-rhs"
                }
                onClick={() => {
                  setactivesection1("subscription");
                }}
              >
                <p>Subscription & Billing</p>
              </div>
            </div>
            {activesection1 == "spendhistory" ? (
              <div className="basicdetails-maindiv">
                 <div className="spendhistorytablediv">
                        {
                          spendhistorydata?.length > 0 ?
                          <table class="table">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Slides converted</th>
                              <th>Credits Used</th>
                              <th>Remaining</th>
                              <th>Plan</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              spendhistorydata?.map((item, index) => {
                                return (
                                  <tr>
                                    <td>{formatCreatedDateWithSuffix(item?.created_at)}</td>
                                    <td>{item?.slides_converted}</td>
                                    <td className="creditsusedcolor">-{item?.credits_used}</td>
                                    <td>{item?.remaining}</td>
                                    <td>{item?.plan}</td>
                                  </tr>
                                );
                              })
                            }
                          </tbody>
                        </table> : 
                        <p className="data-not-available">Data not available</p>
                        }
                        
                      </div>
              </div>
            ) : activesection1 == "subscription" ? (
              <div className="basicdetails-maindiv">
                <div className="spendhistorytablediv">
                        {
                          bilingdata?.length > 0 ?
                          <table class="table">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Plan</th>
                              <th>Slides</th>
                              <th>Amount Paid</th>
                              <th>Promo Code</th>
                              <th>Payment ID</th>
                              {/* <th>Status</th> */}
                              
                            </tr>
                          </thead>
                          <tbody>
                            {
                              bilingdata?.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{formatCreatedDateWithSuffix(item?.created_at)}</td>
                                    <td>{item?.plan}</td>
                                    <td>{item?.plantype == "daysvalidity" ? "Unlimited" : parseInt(item?.slides) + parseInt(item?.additional_slides)}</td>
                                    <td>{item?.currency} {item?.total}</td>
                                    <td>{item?.promocode ? item?.promocode : "--"}</td>
                                    <td>{item?.paymentid}</td>
                                      
                                      
                                    
                                  </tr>
                                );
                              })

                            }
                            
                            {/* <tr>
                              <td>10 March 2026</td>
                              <td>Monthly</td>
                              <td>$ 10</td>
                              <td className="creditsusedcolor">Expired</td>
                              
                            </tr> */}
                          </tbody>
                        </table> :
                        <p className="data-not-available">Data not available</p>
                        }
                        
                      </div>
              </div>
            ) 
            : null}
          </div>
        </div>
      )}
           </Modal.Body>
        </Modal>

      </div>
    );
}

export default UserDetailsModal;